import { ButtonGroup, Button, Box, BlockStack } from '@shopify/polaris';
import { LayoutBlockIcon, SettingsIcon } from '@shopify/polaris-icons';
import { lazy, Suspense } from 'react';
import { useSelectionStore } from '@/state/selectionStore';
import { SectionTree } from '@/sections/SectionTree';

const ThemeSettingsMenu = lazy(() =>
  import('./sidebar/ThemeSettingsMenu').then((m) => ({ default: m.ThemeSettingsMenu })),
);

export function Sidebar() {
  const viewMode = useSelectionStore((s) => s.viewMode);
  const setViewMode = useSelectionStore((s) => s.setViewMode);

  return (
    <aside
      style={{
        width: 300,
        flexShrink: 0,
        borderRight: '1px solid var(--p-color-border)',
        background: 'var(--p-color-bg-surface)',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        padding="300"
        borderBlockEndWidth="025"
        borderColor="border"
        background="bg-surface"
      >
        <ButtonGroup variant="segmented" fullWidth>
          <Button
            pressed={viewMode === 'sections'}
            onClick={() => setViewMode('sections')}
            icon={LayoutBlockIcon}
          >
            Sections
          </Button>
          <Button
            pressed={viewMode === 'theme-settings'}
            onClick={() => setViewMode('theme-settings')}
            icon={SettingsIcon}
          >
            Theme
          </Button>
        </ButtonGroup>
      </Box>
      <BlockStack gap="0">
        {viewMode === 'sections' ? (
          <SectionTree />
        ) : (
          <Suspense fallback={<div style={{ padding: 16 }}>Loading…</div>}>
            <ThemeSettingsMenu />
          </Suspense>
        )}
      </BlockStack>
    </aside>
  );
}
